import { render, staticRenderFns } from "./LanguagePreview.vue?vue&type=template&id=42b3e8b7&"
import script from "./LanguagePreview.vue?vue&type=script&lang=js&"
export * from "./LanguagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports